/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const UserAddIcon = createIcon(
  '0 0 20 20',
  <path d="M5 6a4 4 0 1 1 4.516 3.967.018.018 0 0 0 .002.037 7 7 0 0 1 3.813 1.281A5 5 0 0 0 10.416 18H1l1.071-3.214a7 7 0 0 1 6.411-4.782.018.018 0 0 0 .002-.037A4 4 0 0 1 5 6m11 13h-2v-2h-2v-2h2v-2h2v2h2v2h-2z" />,
);
